import axios from 'axios';

export function remove(uuid) {
  return axios.delete(`/v1/saml/client/customers/${uuid}`);
}

export default {};
